// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search {
    margin-top: 56px;
}

.search-wrap {
    display: flex;
    flex-direction: column;
    justify-content: start;
}

.search-find {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 15px 0;
    box-sizing: border-box;
}

.search-wrap > .product-list > .product-item {
    width: calc(20% - 32px);
}

@media screen and (max-width: 1300px) {
    .search-wrap > .product-list > .product-item {
        width: calc(20% - 16px);
        margin: 0 8px 16px 8px;
    }
}

@media screen and (max-width: 767px) {
    .search-wrap > .product-list > .product-item {
        width: calc(50% - 16px);
    }
}

@media screen and (max-width: 576px) {
    .search-wrap > .product-list > .product-item {
        width: calc(50% - 8px);
        margin: 0 4px 16px 4px;
    }
}

.search-wrap > .product-list > .product-item__img {
    height: 494px;
}

@media screen and (max-width: 1300px) {
    .search-wrap > .product-list > .product-item__img {
        height: 440px;
    }
}

@media screen and (max-width: 1200px) {
    .search-wrap > .product-list > .product-item__img {
        height: 380px;
    }
}

@media screen and (max-width: 440px) {
    .search-wrap > .product-list > .product-item__img {
        height: 260px;
    }
}
`, "",{"version":3,"sources":["webpack://./resources/views/site/pages/search/main.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,sBAAsB;IAC1B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".search {\n    margin-top: 56px;\n}\n\n.search-wrap {\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n}\n\n.search-find {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    padding: 15px 0;\n    box-sizing: border-box;\n}\n\n.search-wrap > .product-list > .product-item {\n    width: calc(20% - 32px);\n}\n\n@media screen and (max-width: 1300px) {\n    .search-wrap > .product-list > .product-item {\n        width: calc(20% - 16px);\n        margin: 0 8px 16px 8px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .search-wrap > .product-list > .product-item {\n        width: calc(50% - 16px);\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .search-wrap > .product-list > .product-item {\n        width: calc(50% - 8px);\n        margin: 0 4px 16px 4px;\n    }\n}\n\n.search-wrap > .product-list > .product-item__img {\n    height: 494px;\n}\n\n@media screen and (max-width: 1300px) {\n    .search-wrap > .product-list > .product-item__img {\n        height: 440px;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .search-wrap > .product-list > .product-item__img {\n        height: 380px;\n    }\n}\n\n@media screen and (max-width: 440px) {\n    .search-wrap > .product-list > .product-item__img {\n        height: 260px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
